import { createContext, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { QUIET } from './posStyles'
import type { PosCashSession, PosCashStatus } from './types'

export interface CashRegisterContextValue {
  status: PosCashStatus | undefined
  unavailable: boolean
  open: () => void
}
export const CashRegisterContext = createContext<CashRegisterContextValue | null>(null)
export const useCashRegister = () => useContext(CashRegisterContext)
/** Business days can run past midnight, so a calendar date is no signal; a session this old has missed its closing. */
export const closingOverdue = (session: PosCashSession) => Date.now() - new Date(session.openedAt).getTime() > 20 * 60 * 60 * 1000
export function CashRegisterNotice() {
  const { t, i18n } = useTranslation('posOrdering')
  const cash = useCashRegister()
  const session = cash?.status?.session
  const overdue = !cash?.unavailable && session?.state === 'open' && closingOverdue(session)
  if (!cash || (!cash.unavailable && session?.state === 'open' && !overdue)) return null
  return <div className="flex flex-wrap items-center justify-between gap-2 rounded-xl bg-status-warning/15 px-4 py-2.5 text-[15px] font-semibold" role="status">
    <span>{overdue ? t('cash.closingOverdue', { date: new Date(session.openedAt).toLocaleDateString(i18n.language, { day: '2-digit', month: '2-digit' }) })
      : t(cash.unavailable || !cash.status ? 'cash.unavailable' : session?.state === 'counting' ? 'cash.countingNotice' : 'cash.openRequired')}</span>
    <Button variant="ghost" className={cn(QUIET, 'h-11 px-4')} onClick={cash.open}>{t('cash.view')}</Button>
  </div>
}
